import HipAPI from '@/lib/HipApi';

const hipApi = HipAPI.getInstance();

const state = () => ({
    tenants: [],
});

const mutations = {
    setTenants(state: any, data: any) {
        state.tenants = data;
    },
};

const actions = {
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
